import { Component } from '@angular/core';
import { AppdataService } from '../../service/appdata.service';

@Component({
  selector: 'app-useraccount',
  standalone: false,

  templateUrl: './useraccount.component.html',
  styleUrl: './useraccount.component.scss'
})
export class UseraccountComponent {
  constructor(
    private appData: AppdataService,
  ) {
    appData.showHeaderBackButton.next(true);
  }
}
